module.exports = __webpack_public_path__ + "static/img/performance_2.e70a4337.jpg";